"use client";
import { get_user_payment_methods_query } from '@core/services/checkout';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

export const InstallmentPaymentGatewaysContext = createContext(null);

export const InstallmentPaymentGatewaysContextProvider = ({ children }) => {

    const [installment_payment_gateways, set_installment_payment_gateways] = useState([]);

    const get_installment_payment_gateways = async () => {
        const result = await get_user_payment_methods_query();
        if (result?.status) {
            set_installment_payment_gateways(result?.data?.filter(item => item?.is_installment));
        }
    }

    useEffect(() => {
        get_installment_payment_gateways();
    }, []);

    const values = useMemo(() => ({
        installment_payment_gateways
    }), [installment_payment_gateways]);

    return (
        <InstallmentPaymentGatewaysContext.Provider value={values}>
            {children}
        </InstallmentPaymentGatewaysContext.Provider>
    );
};

export const useInstallmentPaymentGatewaysContext = () => useContext(InstallmentPaymentGatewaysContext)